import { ValidatorPosition } from '../../position/validator-position';
export const config = {
    value: 'filterCustom',
    position: [ValidatorPosition.filter],
};
